.card,
.cardCollapsed {
  position: fixed !important;
  z-index: 999;
  bottom: 60px;
  left: 195px;
  height: 580px;
  width: 450px;
}

.cardCollapsed {
  left: 95px;
}

.cardMobile {
  position: fixed !important;
  z-index: 1200;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.btn,
.btnCollapsed {
  position: fixed !important;
  z-index: 999;
  left: 20px;
  bottom: 60px;
  height: 46px !important;
  width: 133px !important;
}

.btnCollapsed {
  left: 12px;
  width: 52px !important;
  border: 1px solid #4e91f4 !important;
}

.btnText {
  color: #3d80f3 !important;
  font-size: 14px;
  font-weight: 600;
}

.close {
  cursor: pointer;
}

.close:hover {
  font-weight: bold;
}

.titleIconContainer {
  position: relative;
  margin: 0 12px 0 0;
  background: rgb(61 128 243 / 30%);
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.titleIconContainer > svg {
  position: absolute;
  top: 7px;
  left: 7px;
}

.controls {
  position: sticky;
  padding: 20px 15px;
  border-top: 1px solid #eee;
  width: 100%;
  height: 56px;
}

.input {
  max-width: 75%;
  padding-right: 2px !important;
}

.micBtn {
  padding: 0 !important;
  margin: 0 !important;
}

.sendBtn {
  height: 36px !important;
  width: 36px !important;
}

.sendIcon {
  transform: scale(0.8);
  margin: 4px 1px 0 0;
}

.micDef,
.micRec {
  transform: scale(0.8);
  padding-top: 2px !important;
}

.micDef > path {
  stroke: #b3b3b3 !important;
}

.micRec > path {
  stroke: rgb(235 35 35) !important;
}

.quoteIcon {
  cursor: pointer;
}

.promptIdeasCard {
  width: 345px;
  height: 341px;
  background-color: #f4f4f4 !important;
  margin-bottom: 30px !important;
  border: 1px solid #eee;
}

.promptIdeasRow {
  padding: 10px;
  margin: 10px 20px;
  background-color: #fff;
  font-size: 12px;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid #eee;
}

.promptIdeasRow:hover {
  border: 1px solid #aaa;
}

.promptIdeasIcon {
  fill: #181818;
  transform: scale(0.6);
  margin-top: 4px;
}

.messages,
.messagesMobile {
  padding: 15px;
  height: 440px;
  width: 100%;
  overflow-y: scroll;
  overscroll-behavior: none;
}

.messagesMobile {
  height: calc(100vh - 150px);
}

.msg {
  width: 100%;
}

.msgText {
  max-width: 82%;
  margin: 5px;
  padding: 15px;
  overflow-wrap: anywhere;
  font-size: 14px;
  white-space: pre-wrap;
}

.msgCopy {
  padding: 0 15px;
}

.msgCopyIcon {
  cursor: pointer;
}

.msgUser {
  background-color: #3d80f3;
  border-radius: 30px 30px 0;
  color: #fff;
}

.msgAssistant {
  background-color: #f4f4f4;
  border-radius: 30px 30px 30px 0;
  color: #181818;
}

.msgSpecial {
  background-color: #cee0ff;
  border-radius: 30px 30px 30px 0;
  color: #181818;
  margin-bottom: 30px;
}

.msgTime {
  font-size: 10px;
  color: #b3b3b3;
  padding: 0 5px;
}

.poweredByIcon {
  filter: drop-shadow(0 0 6px #fff);
}

.poweredByCompanyName {
  font-weight: bold;
  color: #111 !important;
}

.expirationCard {
  position: absolute !important;
  top: calc(40% - 30px);
  left: 50%;
  transform: translate(-50%, 0);
  overscroll-behavior: none;
  border: 1px solid #3d80f3;
  width: 90%;
  padding: 0 !important;
  background-color: #f4f4f4 !important;
  cursor: pointer;
}

.expirationCardIcon {
  margin-top: 10px;
}

.expirationCardDescription {
  color: #3d80f3 !important;
  font-size: 16px;
  font-weight: 500;
}

.expirationCardLink {
  color: #3d80f3 !important;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.poweredByModal {
  color: #111 !important;
  text-shadow: 0 0 2px #fff;
}

.blueText {
  color: #3d80f3 !important;
}

.modalCard {
  position: relative;
  margin: 10px !important;
  width: 300px;
  height: 330px;
  background-color: #f4f4f4 !important;
}

.modalCardTitle {
  font-size: 32px;
  font-weight: bold;
}

.modalCardFeatures {
  font-size: 12px;
  margin: 5px 0;
}

.modalCardFeaturesLine {
  margin: 7px 0;
}

.modalCardFeaturesBasicCheck {
  margin: 2px 10px 0 0;
}

.modalCardButton {
  position: absolute;
  left: 36px;
  bottom: 10px;
}

.modalNavDefault,
.modalNavPrimary {
  width: 100px;
  border-radius: 10px !important;
}

.modalNavDefault {
  background-color: #f1f1f1 !important;
  color: #414141 !important;
  border: 0 !important;
  margin-right: 20px;
}

.modalCardCheckout {
  min-height: 132px;
  background-color: #f4f4f4 !important;
}

.modalCheckoutContent {
  padding: 15px 0;
  justify-content: flex-start !important;
}

.modalCheckoutFeaturesTitle {
  font-size: 20px;
  font-weight: 600;
}

.modalCheckoutFeaturesContent {
  font-size: 16px;
}

.modalCheckoutFeaturesLine {
  font-size: 16px;
  padding: 7px 0;
}

.modalCheckoutFeaturesBasicCheck {
  margin: 6px 10px 0 0;
}

.micDef:hover > path {
  stroke: #939393 !important;
}

.msgCopyIcon:hover > path {
  stroke: #939393 !important;
}
